module.exports = __webpack_public_path__ + "static/media/4d-engine-2.3a385bd0.jpg";